import { Injectable } from '@angular/core';

import { LocalStorageService } from './local-storage.service';
import { TIAggRequest } from '../common-interfaces-classes/TIAggRequest';
import { AggregationRequest } from '../common-interfaces-classes/AggregationRequest';
import { Router } from '@angular/router';
import { SessionStorageService } from './session-storage.service';
import { FilterDataHandlerService } from './filter-data-handler.service';
import { GeneralConstants } from '../constants/GeneralConstants';

@Injectable({
  providedIn: 'root'
})
export class TalentInsightsReqHandlerService {

  constructor(
    private localStorageService: LocalStorageService,
    private route: Router,
    private sessionStorageService: SessionStorageService,
    private filterDataHandlerService: FilterDataHandlerService
  ) { }

  get talentInsightRequest() : AggregationRequest {
    const request = new TIAggRequest();
    delete request.module;
    return request;
  }

  get isTalentInsightsTab() {
    const url = this.route.url;
    return (url?.startsWith("/report-details") || url?.startsWith("/talentpool-insights"))
  }

  get isCompanyInsightsTab() {
    const url = this.route.url;
    return (url?.startsWith("/company-details") || url?.startsWith("/company-compare"));
  }

  get isCompanyCompareTab() {
    const url = this.route.url;
    return (url?.startsWith("/company-compare") || url?.startsWith("/webbtree-company-list"));

  }


  setSessionDataForCurrentRedirection(uniqueHash: string, talentfilterdata: any) {
    this.sessionStorageService.setItem(`talentfilters-${uniqueHash}`, JSON.stringify(talentfilterdata));
    this.sessionStorageService.setItem(
      `${GeneralConstants.LS_KEYS.TALENT_FILTERS}-${uniqueHash}`,
      JSON.stringify(this.filterDataHandlerService.fetchFilterData)
    );
  }

  setSessionDataForCompanyInsightsRedirection(uniqueHash: string, companyinsightsdata: any) {
    this.sessionStorageService.setItem(`companyfilters-${uniqueHash}`, JSON.stringify(companyinsightsdata));
    this.sessionStorageService.setItem(
      `${GeneralConstants.LS_KEYS.COMPANY_FILTERS}-${uniqueHash}`,
      JSON.stringify(this.filterDataHandlerService.fetchFilterData)
    );
  }
}
